import axios from "axios";
import qs from "qs";
import { Toast } from "antd-mobile";
import * as Api from "./api";
let createHistory = require("history").createHashHistory;
const history = createHistory();
export default class Http {
  constructor() {
    this.baseUrl = Api.ROOT_HTTP_BASEURL;
  }
  /**
   * 微信授权后登陆
   * @param api 请求的接口名
   * @param data 请求参数
   * @return promise 返回promise
   */
  login(api, data) {
    const _this = this;
    let params = qs.stringify(data);
    return new Promise((resolve, reject) => {
      axios
        .post(_this.baseUrl + api, params, { timeout: 20000 })
        .then((res) => {
          resolve(res);
        })
        .catch((error) => {
          Toast.info("网络异常", 1);
        });
    });
  }
  /**
   * get请求
   * @param api 请求的接口名
   * @param data 请求参数
   * @return promise 返回promise
   */
  get(api, data) {
    const _this = this;
    let params = qs.stringify(data);
    let headers = {};
    let loginData = JSON.parse(localStorage.getItem("loginData"));
    // let isApp = loginData.isApp;
    // let customKey = loginData.customKey;
    // console.log("customKey", customKey);
    let isApp = "";
    let customKey = "";
    if (loginData) {
      isApp = loginData.isApp;
      customKey = loginData.customKey;
    }
    let sourceType = isApp == "true" ? "app" : "HF";
    if (loginData) {
      if (customKey) {
        headers = {
          "Content-Type": "application/x-www-form-urlencoded",
          appVersion: "0.0.1",
          sourceType: sourceType,
          authorization: loginData.accessToken || "",
          customKey: customKey,
        };
      } else {
        headers = {
          "Content-Type": "application/x-www-form-urlencoded",
          appVersion: "0.0.1",
          sourceType: sourceType,
          authorization: loginData.accessToken || "",
        };
      }
      // headers = {
      //   "Content-Type": "application/x-www-form-urlencoded",
      //   appVersion: "0.0.1",
      //   sourceType: sourceType,
      //   authorization: loginData.accessToken || "",
      //   customKey:customKey,
      // };
    } else {
      if (customKey) {
        headers = {
          "Content-Type": "application/x-www-form-urlencoded",
          appVersion: "0.0.1",
          sourceType: sourceType,
          customKey: customKey,
        };
      } else {
        headers = {
          "Content-Type": "application/x-www-form-urlencoded",
          appVersion: "0.0.1",
          sourceType: sourceType,
        };
      }
    }
    return new Promise((resolve, reject) => {
      axios
        .get(_this.baseUrl + api, {
          params: params,
          headers: headers,
        })
        .then((res) => {
          resolve(res);
        })
        .catch((error) => {
          if (error && error.response) {
            let errCode = error.response.status;
            errCode = Number(errCode);
            if (errCode === 401 || errCode === 500) {
              localStorage.removeItem("code");
              localStorage.removeItem("loginData");
              window.location.replace(Api.AUTH_GLOBAL_URL);
            } else {
              Toast.info("网络异常", 1);
            }
          } else {
            let errorConfig = error.config;
            if (
              errorConfig.url.indexOf("GetPayToken") > 0 ||
              errorConfig.url.indexOf("authorizeOfGZH") > 0
            ) {
              localStorage.removeItem("code");
              localStorage.removeItem("loginData");
              window.location.replace(Api.AUTH_GLOBAL_URL);
            }
            Toast.info("网络异常", 1);
            setTimeout(() => {
              Toast.hide();
            }, 2000);
          }
        });
    });
  }
  /**
	 *post请求
	 @param api 请求的接口名
	 @param data 请求参数
	 @return promise 返回promise
	 */
  post(api, data) {
    const _this = this;
    let params = qs.stringify(data);
    let headers = {};
    let loginData = JSON.parse(localStorage.getItem("loginData"));
    // let isApp = localStorage.getItem("isApp");
    // let customKey = localStorage.getItem("customKey");
    let isApp = "";
    let customKey = "";
    if (loginData) {
      isApp = loginData.isApp;
      customKey = loginData.customKey;
    }
    let sourceType = isApp == "true" ? "app" : "HF";
    if (loginData) {
      // loginData = JSON.parse(loginData);
      if (customKey) {
        headers = {
          "Content-Type": "application/x-www-form-urlencoded",
          appVersion: "0.0.1",
          sourceType: sourceType,
          authorization: loginData.accessToken || "",
          customKey: customKey,
        };
      } else {
        headers = {
          "Content-Type": "application/x-www-form-urlencoded",
          appVersion: "0.0.1",
          sourceType: sourceType,
          authorization: loginData.accessToken || "",
        };
      }
    } else {
      if (customKey) {
        headers = {
          "Content-Type": "application/x-www-form-urlencoded",
          appVersion: "0.0.1",
          sourceType: sourceType,
          customKey: customKey,
        };
      } else {
        headers = {
          "Content-Type": "application/x-www-form-urlencoded",
          appVersion: "0.0.1",
          sourceType: sourceType,
        };
      }
    }
    return new Promise((resolve, reject) => {
      axios
        .post(_this.baseUrl + api, params, { headers: headers, timeout: 20000 })
        .then((res) => {
          resolve(res);
        })
        .catch((error) => {
          if (error && error.response) {
            let errCode = error.response.status;
            errCode = Number(errCode);
            if (errCode === 401 || errCode === 500) {
              localStorage.removeItem("code");
              localStorage.removeItem("loginData");
              window.location.replace(Api.AUTH_GLOBAL_URL);
            } else {
              Toast.info("网络异常", 1);
            }
          } else {
            let errorConfig = error.config;
            if (
              errorConfig.url.indexOf("GetPayToken") > 0 ||
              errorConfig.url.indexOf("authorizeOfGZH") > 0
            ) {
              localStorage.removeItem("code");
              localStorage.removeItem("loginData");
              window.location.replace(Api.AUTH_GLOBAL_URL);
            }
            Toast.info("网络异常", 1);
            setTimeout(() => {
              Toast.hide();
            }, 2000);
          }
        });
    });
  }
  /**
   * post Json请求
   * @param api 请求的接口名
   * @param data 请求参数
   * @return promise 返回promise
   */
  postJSON(api, data) {
    const _this = this;
    let params = data;
    let headers = {};
    let loginData = JSON.parse(localStorage.getItem("loginData"));
    // let isApp = loginData.isApp;
    // let customKey = loginData.customKey;
    let isApp = "";
    let customKey = "";
    if (loginData) {
      isApp = loginData.isApp;
      customKey = loginData.customKey;
    }
    let sourceType = isApp == "true" ? "app" : "HF";
    if (loginData) {
      // loginData = JSON.parse(loginData);
      if (customKey) {
        headers = {
          "Content-Type": "application/json",
          appVersion: "0.0.1",
          sourceType: sourceType,
          authorization: loginData.accessToken || "",
          customKey: customKey,
        };
      } else {
        headers = {
          "Content-Type": "application/json",
          appVersion: "0.0.1",
          sourceType: sourceType,
          authorization: loginData.accessToken || "",
        };
      }
    } else {
      if (customKey) {
        headers = {
          "Content-Type": "application/json",
          appVersion: "0.0.1",
          sourceType: sourceType,
          customKey: customKey,
        };
      } else {
        headers = {
          "Content-Type": "application/json",
          appVersion: "0.0.1",
          sourceType: sourceType,
        };
      }
    }
    return new Promise((resolve, reject) => {
      axios
        .post(_this.baseUrl + api, params, { headers: headers, timeout: 20000 })
        .then((res) => {
          resolve(res);
        })
        .catch((error) => {
          if (error && error.response) {
            let errCode = error.response.status;
            errCode = Number(errCode);
            if (errCode === 401 || errCode === 500) {
              localStorage.removeItem("code");
              localStorage.removeItem("loginData");
              window.location.replace(Api.AUTH_GLOBAL_URL);
            } else {
              Toast.info("网络异常", 1);
            }
          } else {
            let errorConfig = error.config;
            if (
              errorConfig.url.indexOf("GetPayToken") > 0 ||
              errorConfig.url.indexOf("authorizeOfGZH") > 0
            ) {
              localStorage.removeItem("code");
              localStorage.removeItem("loginData");
              window.location.replace(Api.AUTH_GLOBAL_URL);
            }
          }
        });
    });
  }
  /**
   * 获取浏览器地址栏参数
   * @param locationUrl 浏览器地址栏
   * @param name 要获取的参数名
   * @return name
   *  */
  getSearchByName(locationUrl, name) {
    let searchParams = new URLSearchParams(locationUrl);
    return searchParams.get(name);
  }
  UrlSearchCode(locationUrl) {
    var name, value;
    var str = locationUrl; //取得整个地址栏
    var num = str.indexOf("?");
    str = str.substr(num + 1); //取得所有参数   stringvar.substr(start [, length ]

    var arr = str.split("&"); //各个参数放到数组里
    for (var i = 0; i < arr.length; i++) {
      num = arr[i].indexOf("=");
      if (num > 0) {
        name = arr[i].substring(0, num);
        value = arr[i].substr(num + 1);
        if (name == "code") {
          return value;
        }
      }
    }
  }
  formatNumber(n) {
    n = n.toString();
    return n[1] ? n : "0" + n;
  }
  /**
   * 时间转化
   * @param value 时间参数
   * @return result
   *  */
  formatSeconds(value) {
    let theTime = parseInt(value); // 秒
    let theTime1 = 0; // 分
    let theTime2 = 0; // 小时
    // alert(theTime);
    if (theTime > 60) {
      theTime1 = parseInt(Math.floor(theTime / 60));
      theTime = parseInt(Math.floor(theTime % 60));
      // alert(theTime1+"-"+theTime);
      if (theTime1 > 60) {
        theTime2 = parseInt(theTime1 / 60);
        theTime1 = parseInt(theTime1 % 60);
      }
    }
    let seconds = parseInt(theTime);
    seconds = seconds >= 10 ? seconds : "0" + seconds;
    var result = "" + seconds + "秒";
    if (theTime1 > 0) {
      result = "" + parseInt(theTime1) + "分" + result;
    }
    if (theTime2 > 0) {
      result = "" + parseInt(theTime2) + "小时" + result;
    }
    return result;
  }
  /**
   * 时间转化-毫秒转自定义格式的日期
   * @param number 时间参数
   * @return format 日期格式
   *  */
  formatTime(number, format) {
    var formateArr = ["Y", "M", "D", "h", "m", "s"];
    var returnArr = [];

    var date = new Date(number.replace(/-/g, "/"));
    returnArr.push(date.getFullYear());
    returnArr.push(this.formatNumber(date.getMonth() + 1));
    returnArr.push(this.formatNumber(date.getDate()));

    returnArr.push(this.formatNumber(date.getHours()));
    returnArr.push(this.formatNumber(date.getMinutes()));
    returnArr.push(this.formatNumber(date.getSeconds()));

    for (var i in returnArr) {
      format = format.replace(formateArr[i], returnArr[i]);
    }
    return format;
  }
  handleCouponDiscount(discount) {
    let length = discount.toString().split(".")[1].length;
    return length > 1 ? (discount * 10).toFixed(1) : discount * 10;
  }
}
